/**
 * An organisation's square: its logo when it has one, else its initials on
 * the colour the id always gets (orgTile). One component for the header pill,
 * the org menu, Settings and the public join pages, so they never disagree.
 */

import { useState } from 'react'
import { orgTile } from './orgTheme'

export function OrgTile({ id, name, logoUrl, size, radius, fontSize, border }: {
  id: string; name: string; logoUrl?: string | null
  size: number; radius: number; fontSize: number; border?: string
}) {
  const [broken, setBroken] = useState<string | null>(null)
  const t = orgTile(id, name)
  const base = { width: size, height: size, flex: 'none' as const, borderRadius: radius, border, boxSizing: 'content-box' as const }
  if (logoUrl && broken !== logoUrl) {
    return (
      <span style={{ ...base, background: '#fff', display: 'grid', placeItems: 'center', overflow: 'hidden', boxShadow: border ? undefined : 'inset 0 0 0 1px #ECE9F0' }}>
        <img src={logoUrl} alt="" onError={() => setBroken(logoUrl)} style={{ width: '86%', height: '86%', objectFit: 'contain' }} />
      </span>
    )
  }
  return <span style={{ ...base, background: t.bg, color: t.fg, display: 'grid', placeItems: 'center', fontWeight: 600, fontSize }}>{t.initials}</span>
}
